import React, { Fragment, Component } from 'react'

const ClockDissolve = (props) => {
  const {
    dateTop='30 July 2017',
    dateBottom='15 May 2017',
    ratio=1,
    minFontSize=25,
    maxFontSize=45,
    color='white'
  } = props
  const invertedRatio = 1 - ratio

  const topSize = Math.max(Math.min(ratio * maxFontSize, maxFontSize), minFontSize)
  const bottomSize = Math.max(invertedRatio * maxFontSize, minFontSize)

  const dateTopText = dateTop === 'Invalid Date' ? '' : dateTop
  const dateBottomText = dateTop === 'Invalid Date' ? '' : dateBottom

  return (
    <Fragment>
      <div style={{ fontSize: topSize, color }}>{dateTopText}</div>
      <div style={{ fontSize: bottomSize, color  }}>{dateBottomText}</div>
    </Fragment>
  )
}

// class ClockDissolve extends Component {
//   render () {

//     return (
//       <Fragment>
//         <div style={{ fontSize: ratio * maxFontSize }}>{dateTop}</div>
//         <div style={{ fontSize: invertedRatio * maxFontSize | minFontSize }}>{dateBottom}</div>
//       </Fragment>
//     )
//   }
// }


export default ClockDissolve



// WEBPACK FOOTER //
// ./src/components/ClockDissolve.js